export default __webpack_public_path__ + "static/media/html.df5296ac.png";